import '@fpsm/cxy-tokens/tokens.css';

import { type ReactNode } from 'react';
import { footerItemType, type FooterV2Response, navItemType } from '@cx-web/domain-types';

import FooterGeneralLinks from './components/FooterGeneralLinks/index';
import FooterNav from './components/FooterNav/index';
import FooterSocialsAndDisclaimer from './components/FooterSocialsAndDisclaimer/index';
import styles from './FooterV2.module.css';
import { type CmpProps, type SocialLink } from './types';

export type FooterV2Props = {
  cmpProps?: CmpProps;
  footerData?: FooterV2Response;
  isAdmiralCookieBannerEnabled: boolean;
  legalAge: string;
  legalText: string;
  logo: ReactNode;
  socialLinks: SocialLink[];
};

export const FooterV2 = ({
  cmpProps,
  footerData,
  isAdmiralCookieBannerEnabled,
  legalAge,
  legalText,
  logo,
  socialLinks,
}: FooterV2Props) => {
  return (
    <footer className={styles.footerContainer} data-testid="footer-v2">
      <FooterNav groupType={navItemType.GROUP} levelOne={footerData?.levelOne ?? []} />
      <FooterSocialsAndDisclaimer
        legalAge={legalAge}
        legalText={legalText}
        levelTwo={footerData?.levelTwo ?? []}
        logo={logo}
        logoType={footerItemType.LOGO}
        socialLinks={socialLinks}
      />
      <FooterGeneralLinks
        cmpProps={cmpProps}
        isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
        levelThree={footerData?.levelThree ?? []}
      />
    </footer>
  );
};
